export default __webpack_public_path__ + "static/media/logo_word.c3499582.svg";